import React, { useEffect, useState } from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux"
import WellnessScore from '../WellnessScore'
import AssessmentIcon from '@mui/icons-material/Assessment'
import SummarizeIcon from '@mui/icons-material/Summarize'
import EditIcon from '@mui/icons-material/Edit'
import { Button, Grid, Box, Typography, Modal, Card, CardHeader, CardContent, CardActions, Stack, Divider } from '@mui/material'
import { surveyClear } from "../../../reducers/survey"
import { stubTrue } from 'lodash'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";

const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const PreferredCardInProgress = (props) => {
    const AssessmentObject = props.AssessmentObject
    const AssessmentGuid = AssessmentObject.ResponseId_Guid
    const { user: currentUser } = useSelector((state) => state.auth);
    const navigate = useNavigate()

    const handleContinue = (guid) => {
        console.log("continue select")
        fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + props.settings.SessionVariableValues["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' + AssessmentObject.AssessmentProductGuid + '/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        })
            .then(response => response.json())
            .then(response => {
                fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + guid + '/', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: {
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        navigate({ pathname: '/hra', search: createSearchParams({ vi: 'B87190C3-B9C8-41D7-A1C8-10E07FBA0D3E', assmtguid: guid }).toString() })
                    })
            })


    }
    const graphcolors = ['#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
    return (
        <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
            <Card p={3} sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <CardHeader
                    title={
                        <Typography variant="h5" align="center" gutterBottom>{AssessmentObject.SurveyDescription}</Typography>
                    } />
                <CardContent width={"100%"}>
                    <Stack direction="column" gap={1} sx={{ width: "100%", justifyContent: "center", alignItems: "space-between" }}>
                        <Stack direction="column" gap={1} sx={{ width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <Typography variant="subtitle1" align="center">{AssessmentObject.ProgressText}</Typography>

                            <Box sx={{ width: "100%", justifyContent: "center", alignItems: "center" }}>


                                <Box sx={{ backgroundColor: graphcolors[1] + "40", width: "100%", height: "12px", borderRadius: "16px" }}>
                                    <Box sx={{ backgroundColor: graphcolors[1], width: AssessmentObject.PercentCompleted + "%", height: "12px", borderRadius: "16px" }}>

                                    </Box>
                                </Box>

                            </Box>
                            <Typography variant="body2" >{AssessmentObject.PercentCompleted}% Completed</Typography>
                        </Stack>


                    </Stack>
                </CardContent>
                <CardActions>
                    
                    <Stack direction={"column"} sx={{ width: "100%", justifyContent: "center", alignItems: "center" }} gap={1}>

                        <Button variant="contained" onClick={() => handleContinue(AssessmentGuid)} >
                            {AssessmentObject.ContinueButton}
                        </Button>
                    </Stack>
                </CardActions>
                <Box  pb={2} ></Box>
            </Card>

        </motion.div>
    )

}

export default PreferredCardInProgress; 